scrollStarAnimation(".scroll-trigger__first-star", ".star-scroll__bg-black");
scrollStarAnimation(".scroll-trigger__second-star", ".star-scroll__bg-image");

function scrollStarAnimation(triggerClass, maskClass) {
  let params;

  if (window.innerWidth <= 991) {
    params = {
      multiplyScale: 12,
    };
  } else {
    params = {
      multiplyScale: 6,
    };
  }

  let state = {
    progress: 0,
    lerpProgress: 0,
    render: true,
  };

  const firstTrigger = document.querySelector(triggerClass);
  const mask = document.querySelector(maskClass);

  window.addEventListener("scroll", function () {
    const targetPosition =
      window.pageYOffset + firstTrigger.getBoundingClientRect().top;
    const windowPosition = window.pageYOffset + window.innerHeight;
    const triggerHeight = firstTrigger.clientHeight;

    if (
      targetPosition < windowPosition &&
      targetPosition + triggerHeight > windowPosition
    ) {
      state.progress = (windowPosition - targetPosition) / triggerHeight;
    } else if (targetPosition > windowPosition) {
      state.progress = 0;
    } else if (targetPosition + triggerHeight < windowPosition) {
      state.progress = 1;
    }
  });

  function step() {
    if (state.render === true) {
      state.lerpProgress = lerp(state.lerpProgress, state.progress, 0.1);
      const invertLerpProgress = Math.abs(state.lerpProgress - 1);
      const scale = invertLerpProgress * params.multiplyScale * 100;

      mask.setAttribute(
        "style",
        " -webkit-mask-size: " + scale + "%; mask-size: " + scale + "%;"
      );
    }
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);

  function lerp(start, end, amt) {
    return (1 - amt) * start + amt * end;
  }
}
